<!--
 * @Author: 田鑫
 * @Date: 2021-08-09 20:56:33
 * @LastEditors: 田鑫
 * @LastEditTime: 2021-08-09 22:52:49
 * @Description: 标签管理
-->
<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>健康在线</el-breadcrumb-item>
        <el-breadcrumb-item>标签管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="hx-form-container box-shadow">
      <el-form :model="listParams" label-width="100px" ref="form">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="分类：" prop="categoryId">
              <el-select clearable style="width: 100%" v-model="listParams.categoryId" placeholder="请选择分类">
                <el-option v-for="(item, index) in categoryList" :key="index" :label="item.title" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label=" ">
              <el-button @click="loadTableData" type="primary">查询</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <hx-table-result :loading="tableLoading">
      <hx-table-result-col>
        <div class="wrap-table-info-display">
          <el-button class="align-left" type="primary" size="small" @click="toCreate">新增标签</el-button>

          <span class="table-info-display">
            <span>总条数：</span>
            <span class="alert-text ft16">{{ tableData.length }}</span>
          </span>
        </div>
      </hx-table-result-col>

      <el-table slot="content" v-loading="tableLoading" :data="tableData" max-height="800" border>
        <el-table-column align="center" label="排序" prop="sort"></el-table-column>
        <el-table-column align="center" label="标签" prop="tagName"></el-table-column>
        <el-table-column align="center" label="分类" prop="advCategoryName" />
        <el-table-column align="center" label="状态" prop="isEnable">
          <template slot-scope="scope">
            <span v-show="scope.row.isEnable === 1" style="#22bb52">启用</span>
            <span v-show="scope.row.isEnable === 2" style="#ffa500">禁用</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="editRow(scope.row)">修改</el-button>
            <confirm-button type="text" style="margin: 0 10px" title="确认要删除该条数据？" @confirmed="deleteRow(scope.row.id)">
              <span>删除</span>
            </confirm-button>
          </template>
        </el-table-column>
      </el-table>
    </hx-table-result>

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="500px">
      <el-form :model="dialogParams" ref="dialogForm" :rules="dialogRules" label-width="120px">
        <el-form-item prop="advCategoryId" label="分类：">
          <el-select clearable style="width: 100%" v-model="dialogParams.advCategoryId" placeholder="请选择分类">
            <el-option v-for="(item, index) in categoryList" :key="index" :label="item.title" :value="item.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="标签名称：" prop="tagName">
          <el-input v-model="dialogParams.tagName" placeholder="请输入标签名称"></el-input>
        </el-form-item>
        <el-form-item label="排序：" prop="sort">
          <el-input-number v-model="dialogParams.sort"></el-input-number>
        </el-form-item>
        <el-form-item label="状态：" prop="isEnable">
          <el-switch v-model="dialogParams.isEnable" active-text="启用" inactive-text="禁用"> </el-switch>
        </el-form-item>
        <el-form-item label=" ">
          <div style="text-align: right">
            <el-button @click="dialogCancel">取消</el-button>
            <el-button type="primary" @click="dialogConfirm" :disabled="isDisabled">保存</el-button>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      listParams: {
        categoryId: "",
      },
      categoryList: [],
      tableLoading: false,
      tableData: [],
      dialogTitle: "",
      dialogVisible: false,
      dialogParams: {
        advCategoryId: "",
        tagName: "",
        sort: 1,
        isEnable: false,
      },
      dialogRules: {
        advCategoryId: [{ required: true, message: "请选择分类", trigger: "change" }],
        tagName: [{ required: true, message: "请输入标签名称", trigger: "blur" }],
        sort: [{ required: true, trigger: "change" }],
        isEnable: [{ required: true, trigger: "change" }],
      },
      isDisabled: false,
    };
  },
  mounted() {
    this.loadCategoryList();
    this.loadTableData();
  },
  methods: {
    loadCategoryList() {
      this.$http({
        url: global.apiUrl + "/advisory/category/list",
        method: "GET",
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.categoryList = res.body.data;
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    loadTableData() {
      this.tableLoading = true;
      this.$http({
        url: global.apiUrl + "/advisory/tag/list",
        method: "GET",
        params: {
          categoryId: this.listParams.categoryId,
        },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.tableData = res.body.data;
          }
          this.tableLoading = false;
        })
        .catch(err => {
          console.error(err);
          this.tableLoading = false;
        });
    },
    toCreate() {
      this.dialogParams = this.$options.data().dialogParams;
      this.dialogTitle = "新增标签";
      this.dialogVisible = true;
    },
    editRow(row) {
      const params = JSON.parse(JSON.stringify(row));
      params.isEnable = params.isEnable === 1;
      this.dialogParams = params;
      this.dialogTitle = "修改标签";
      this.dialogVisible = true;
    },
    deleteRow(id) {
      this.$http({
        url: global.apiUrl + "/advisory/tag/delete",
        method: "DELETE",
        params: {
          id,
        },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.$message.success("删除成功");
            this.loadTableData();
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    dialogCancel() {
      this.dialogVisible = false;
    },
    dialogConfirm() {
      this.$refs.dialogForm.validate(valid => {
        if (valid) {
          this.isDisabled = true;
          const params = Object.assign({}, this.dialogParams);
          const url = params.id ? "/advisory/tag/edit" : "/advisory/tag/add";
          const method = params.id ? "PUT" : "POST";
          params.isEnable = params.isEnable ? 1 : 2;
          this.$http({
            url: global.apiUrl + url,
            method: method,
            body: params,
          })
            .then(res => {
              if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
                this.$message.success("保存成功");
                this.dialogVisible = false;
                this.loadTableData();
              } else {
              }
              this.isDisabled = false;
            })
            .catch(err => {
              console.error(err);
              this.isDisabled = false;
            });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.home-container {
  .alert-text {
    color: #e9a021;
    cursor: default;
  }
}
</style>
